import React from 'react';
import { ControlType } from './api';
import DynamicButton from './components/Button';
import DynamicCheckList from './components/CheckList';
import DynamicForeach from './components/Foreach';
import DynamicForm from './components/Form';
import Grid from './components/Grid';
import DynamicItemList from './components/ItemList';
import DynamicMenuBar from './components/MenuBar';
import DynamicSelect from './components/Select';
import Stack from './components/Stack';
import DynamicSummaryList from './components/SummaryList';
import DynamicTabs from './components/Tabs';
import DynamicText from './components/Text';
import TextBox from './components/TextBox';
import DynamicScan from './components/Scan';
import ContentAnchor from './components/ContentAnchor';
import DynamicCheckbox from './components/Checkbox';
import DynamicBox from './components/Box';
export function renderDynamicComponent(key, control, dataState) {
    if (control.kind == ControlType.Grid) {
        return React.createElement(Grid, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.Row || control.kind == ControlType.Column) {
        return React.createElement(Stack, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.Button) {
        return React.createElement(DynamicButton, { key: key, control: control, dataState: dataState });
    }
    else if (control.kind == ControlType.SummaryList) {
        return React.createElement(DynamicSummaryList, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.MenuBar) {
        return React.createElement(DynamicMenuBar, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.Textbox) {
        return React.createElement(TextBox, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.Form) {
        return React.createElement(DynamicForm, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.Foreach) {
        return React.createElement(DynamicForeach, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.ContentAnchor) {
        return React.createElement(ContentAnchor, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.Text) {
        return React.createElement(DynamicText, { key: key, control: control, dataState: dataState }, " ");
        // } else if (control.kind == ControlType.Numeric) {
        // 	return <DynamicNumeric key={key} control={control as INumericControl} dataState={dataState}> </DynamicNumeric>;
        // } else if (control.kind == ControlType.Textarea) {
        // 	return <DynamicTextArea key={key} control={control as ITextareaControl} dataState={dataState}> </DynamicTextArea>;
        // } else if (control.kind == ControlType.DateTime || control.kind == ControlType.Date || control.kind == ControlType.Time) {
        // 	return <DynamicDatePicker key={key} control={control as IDateTimeControl} dataState={dataState}> </DynamicDatePicker>;
    }
    else if (control.kind == ControlType.Checkbox) {
        return React.createElement(DynamicCheckbox, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.Box) {
        return React.createElement(DynamicBox, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.Scan) {
        return React.createElement(DynamicScan, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.ItemList) {
        return React.createElement(DynamicItemList, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.CheckList) {
        return React.createElement(DynamicCheckList, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.Select) {
        return React.createElement(DynamicSelect, { key: key, control: control, dataState: dataState }, " ");
    }
    else if (control.kind == ControlType.Tabs) {
        return React.createElement(DynamicTabs, { key: key, control: control, dataState: dataState }, " ");
    }
    else {
        return React.createElement("div", { key: key },
            "Unknown control: ",
            control.kind);
    }
}
//# sourceMappingURL=render.js.map